import ajax from "@/libs/Ajax";

export default {
    errorlist(params) {
        return ajax.get("/aseapi/console/sysmgr/error/list", {params: params});
    },

    delError(params) {
        return ajax.post("/aseapi/console/sysmgr/error/delerrors", params);
    },

    delAllError(params) {
        return ajax.delete("/aseapi/console/sysmgr/error/delall");
    },
    getErrorMessage(uuid){
      return ajax.get("/aseapi/console/sysmgr/error/getErrorMessage", {params: {uuid: uuid}})
    },
    getMessage(uuid) {
        return ajax.get("/aseapi/console/sysmgr/block/getMessage", {params: {uuid: uuid}})
    },
    getMsTran(uuid) {
        return ajax.get('/aseapi/console/sysmgr/block/transMessage', {params: {uuid: uuid}})
    }
};
